import useStore from "@App/store";

export const useCalculation = () => {

    const state = useStore()

    const organization = state.order.organization
    const service = state.order.service
    const garage = state.order.garage

    const filterBrand = state.filters.brandFilter
    const brand = state.order.brand
    const generation = state.order.generation
    const motorization = state.order.motorization
    const body = state.order.body
    const gearbox = state.order.gearbox
    const mileage = state.order.mileage
    const initialRegistrationDate = state.order.initialRegistrationDate
    const subRepairs = state.order.subRepairs
    const equipments = state.order.equipments
    const premiumServices = state.order.premiumServices

    return {
        organization,
        service,
        garage,
        filterBrand,
        brand,
        generation,
        motorization,
        body,
        gearbox,
        mileage,
        initialRegistrationDate,
        subRepairs,
        equipments,
        premiumServices
    }
}


